import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "n-input-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "نسبة مئوية", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_input_group_label = _resolveComponent("n-input-group-label")!
  const _component_n_form_item = _resolveComponent("n-form-item")!

  return (_openBlock(), _createBlock(_component_n_form_item, {
    rule: {
      required: $props.required,
      message: $props.message,
      trigger: ['input', 'blur'],
    },
    label: $props.label,
    class: _normalizeClass('col-md-' + $props.col + '  mb-' + $props.mb),
    path: $props.path,
    "show-label": $props.ShowLabel,
    "require-mark-placement": "right-hanging",
    "show-require-mark": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_n_input, {
          clearable: "",
          value: $setup.MyValue,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.MyValue) = $event)),
          size: "medium",
          disabled: $props.disabled,
          placeholder: $props.placeholder,
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
          ref: $props.path
        }, null, 8, ["value", "disabled", "placeholder"]),
        _createVNode(_component_n_input_group_label, null, {
          default: _withCtx(() => [
            _createTextVNode("%")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["rule", "label", "class", "path", "show-label"]))
}